import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { api, type DeckSummary } from '../api'
import { ProblemBanner } from '../components/Problem'
import { StatusBadge } from '../components/StatusBadge'
import { eligibleDecks, pickRandomDeck } from '../randomDeck'

export default function Decks() {
  const [decks, setDecks] = useState<DeckSummary[] | null>(null)
  const [error, setError] = useState<unknown>(null)
  const navigate = useNavigate()

  useEffect(() => {
    api
      .listDecks()
      .then((result) => setDecks(result.decks))
      .catch(setError)
  }, [])

  return (
    <>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <h1>Your decks</h1>
        <div className="row">
          {decks && eligibleDecks(decks).length > 0 ? (
            <button
              onClick={() => {
                const deck = pickRandomDeck(decks)
                if (deck) {
                  navigate(`/decks/${deck.deckId}/test`, {
                    state: { randomPick: { deckId: deck.deckId, title: deck.title } },
                  })
                }
              }}
            >
              Random
            </button>
          ) : null}
          {decks && eligibleDecks(decks).length >= 2 ? (
            <Link className="button" to="/test/all">
              All
            </Link>
          ) : null}
          <Link className="button primary" to="/decks/new">
            New deck
          </Link>
        </div>
      </div>

      <ProblemBanner error={error} />

      {decks === null && !error ? <p className="muted">Loading…</p> : null}
      {decks?.length === 0 ? (
        <p className="muted">
          Nothing here yet. Upload a deck as JSON or YAML to get started.
        </p>
      ) : null}

      <div className="grid">
        {decks?.map((deck) => (
          <article className="card" key={deck.deckId}>
            <h2>
              <Link to={`/decks/${deck.deckId}`}>{deck.title}</Link> <StatusBadge status={deck.status} />
            </h2>
            <p className="muted">{deck.description}</p>
            <p className="muted">
              {deck.cardCount} cards · last used {new Date(deck.lastAccessedAt).toLocaleDateString()}
            </p>
          </article>
        ))}
      </div>
    </>
  )
}
